import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import NewAdminDashboard from "./admin/NewAdminDashboard";
import Adminlogin from "./admin/pages/Login";
import AuthMatchOptions from "./landing/pages/AuthMatchOptions";
import Blog from "./landing/pages/Blog";
import Charity from "./landing/pages/Charity";
import Contact from "./landing/pages/Contact";
import DetailedBlog from "./landing/pages/DetailedBlog";
import DetailedMatch from "./landing/pages/DetailedMatch";
import DetailedPitch from "./landing/pages/DetailedPitch";
import EmailVerify from "./landing/pages/EmailVerify";
import Equipments from "./landing/pages/Equipments";
import Events from "./landing/pages/Events";
import Landing from "./landing/pages/Landing";
import Leagues from "./landing/pages/Leagues";
import Matches from "./landing/pages/Matches";
import OrganizerPublicProfile from "./landing/pages/OrganizerPublicProfile";
import Pitches from "./landing/pages/Pitches";
import Privacy from "./landing/pages/Privacy";
import Shop from "./landing/pages/Shop";
import Stats from "./landing/pages/Stats";
import Terms from "./landing/pages/Terms";
import ThirdPartyCheck from "./landing/pages/ThirdPartyCheck";
import NewUserDashboard from "./userDashboard/NewUserDashboard";
import CreatePin from "./userDashboard/pages/CreatePin";
import ForgotPin from "./userDashboard/pages/ForgotPin";
import NewPassword from "./userDashboard/pages/NewPassword";
import PasswordReset from "./userDashboard/pages/PasswordReset";
import PaymentFailed from "./userDashboard/pages/PaymentFailed";
import PaymentSuccessful from "./userDashboard/pages/PaymentSuccessful";
import PaymentVerify from "./userDashboard/pages/PaymentVerify";
import Signin from "./userDashboard/pages/Signin";
import Signup from "./userDashboard/pages/Signup";
import VerifyMail from "./userDashboard/pages/VerifyMail";

function App() {
  const location = useLocation();

  useEffect(() => {
    globalThis.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const handleNumberInput = (event: Event) => {
      const target = event.target as HTMLInputElement | null;
      if (!target || target.tagName !== "INPUT" || target.type !== "number") {
        return;
      }
      const value = target.value ?? "";
      if (value.trim().startsWith("-")) {
        const nextValue = "0";
        if (target.value !== nextValue) {
          target.value = nextValue;
          target.dispatchEvent(new Event("input", { bubbles: true }));
        }
      }
    };

    document.addEventListener("input", handleNumberInput, true);
    return () => document.removeEventListener("input", handleNumberInput, true);
  }, []);

  return (
    <Routes>
      {/* landing pages */}
      <Route path="/" element={<Landing />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/charity" element={<Charity />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      {/* <Route path="/projects" element={<Project />} /> */}
      <Route path="/events" element={<Events />} />
      <Route path="/matches" element={<Matches />} />
      <Route path="/matches/:id" element={<DetailedMatch />} />
      <Route path="/detailed-match" element={<DetailedMatch />} />
      <Route path="/organizers/:id" element={<OrganizerPublicProfile />} />
      <Route path="/detailed-pitch" element={<DetailedPitch />} />
      <Route path="/detailed-pitch/:id" element={<DetailedPitch />} />
      <Route path="/pitches/:id" element={<DetailedPitch />} />
      <Route path="/saca-check-in" element={<EmailVerify />} />
      <Route path="/third-party-check-in" element={<ThirdPartyCheck />} />
      <Route path="/auth-match" element={<AuthMatchOptions />} />
      <Route path="/leagues" element={<Leagues />} />
      <Route path="/pitches" element={<Pitches />} />
      <Route path="/equipments" element={<Equipments />} />
      <Route path="/stats" element={<Stats />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/blogs" element={<Blog />} />
      <Route path="/blogs/:slug" element={<DetailedBlog />} />
      {/* admin pages  */}
      <Route path="/admin-login" element={<Adminlogin />} />
      {/* <Route path="/admin-signup" element={<AdminSignup />} /> */}

      {/* New Admin Dashboard (rebuilt) */}
      <Route path="/admin/*" element={<NewAdminDashboard />} />
      {/* user pages */}
      <Route path="/sign-up" element={<Signup />} />
      <Route path="/sign-in" element={<Signin />} />
      <Route path="/verify-mail" element={<VerifyMail />} />
      <Route path="/create-pin" element={<CreatePin />} />
      <Route path="/forgot-pin" element={<ForgotPin />} />
      <Route path="/reset-password" element={<PasswordReset />} />
      <Route path="/new-password" element={<NewPassword />} />
      <Route path="/new-password" element={<NewPassword />} />
      {/* New User Dashboard (Rebuild) */}
      <Route path="/dashboard/*" element={<NewUserDashboard />} />
      <Route path="/payment-successful" element={<PaymentSuccessful />} />
      <Route path="/payment-verify" element={<PaymentVerify />} />
      <Route path="/payment-failed" element={<PaymentFailed />} />
    </Routes>
  );
}

export default App;
